export default __webpack_public_path__ + "e503ab6f8020ed77992dad3cfbd77cbc.png";